import {
    faEnvelope,
    faHeart as faHeartBold,
    faTimes,
    faVenusMars,
    faAddressCard,
    faBars,
    faCamera,
    faCameraRetro,
    faClock,
    faCloudUploadAlt,
    faCog,
    faExternalLinkAlt,
    faGlobeAmericas,
    faHome,
    faInfoCircle,
    faLips,
    faLock,
    faLockOpen,
    faLockOpenAlt,
    faPhoneAlt,
    faPlusCircle,
    faQuestionCircle,
    faSignOutAlt,
    faSirenOn,
    faSort,
    faStar,
    faStars,
    faTags,
    faTrash,
    faTrashAlt,
    faUser,
    faUserCircle,
    faUsers,
    faAngleUp,
    faAngleDown,
    faAngleRight,
    faCheckCircle as faCheckCircleBold,
    faCheck,
    faAngleLeft,
    faChevronDown,
    faMinus,
    faPlus,
    faLocationCircle,
    faCopy as faCopyBold,
    faFilter,
    faCaretDown,
    faUserGroup as faUserFriendsBold,
    faShareAlt,
    faEuroSign,
    faSack,
    faCircle,
    faCommentsAlt,
    faArrowRight,
    faChevronRight as faChevronRightBold,
    faCreditCard as faCreditCardBold,
    faExclamationTriangle as faExclamationTriangleBold,
    faBan,
    faMinusCircle,
    faBoxOpen,
    faCrown,
    faBell,
    faPersonHalfDress,
    faHousePersonReturn,
    faPeopleRoof,
    faChildReaching,
    faBuildingColumns,
    faMapPin,
    faVideo,
    faUtensils,
    faReplyAll,
    faIdCard,
    faPhoneFlip,
    faPhone,
} from '@fortawesome/pro-solid-svg-icons'
import {
    faHeart,
    faCopy,
    faUserGroup as faUserFriends,
    faStars as faStarsRegular,
    faCheckCircle,
    faChevronRight,
    faCreditCard,
    faExclamationTriangle,
    faSpa,
} from '@fortawesome/pro-regular-svg-icons'
import {
    faWhatsapp,
    faFacebookF,
    faTwitter,
} from '@fortawesome/free-brands-svg-icons'

export const fa_venus_mars = () => {
    return getSvgIconPathData(faVenusMars);
}

export const fa_whatsapp = () => {
    return getSvgIconPathData(faWhatsapp);
}

export const fa_address_card = () => {
    return getSvgIconPathData(faAddressCard);
}

export const fa_bars = () => {
    return getSvgIconPathData(faBars);
}

export const fa_camera = () => {
    return getSvgIconPathData(faCamera);
}

export const fa_camera_retro = () => {
    return getSvgIconPathData(faCameraRetro);
}

export const fa_clock = () => {
    return getSvgIconPathData(faClock);
}

export const fa_cloud_upload_alt = () => {
    return getSvgIconPathData(faCloudUploadAlt);
}

export const fa_cog = () => {
    return getSvgIconPathData(faCog);
}

export const fa_external_link_alt = () => {
    return getSvgIconPathData(faExternalLinkAlt);
}

export const fa_globe_americas = () => {
    return getSvgIconPathData(faGlobeAmericas);
}

export const fa_home = () => {
    return getSvgIconPathData(faHome);
}

export const fa_info_circle = () => {
    return getSvgIconPathData(faInfoCircle);
}

export const fa_lips = () => {
    return getSvgIconPathData(faLips);
}

export const fa_lock = () => {
    return getSvgIconPathData(faLock);
}

export const fa_lock_open = () => {
    return getSvgIconPathData(faLockOpen);
}

export const fa_lock_open_alt = () => {
    return getSvgIconPathData(faLockOpenAlt);
}

export const fa_phone_alt = () => {
    return getSvgIconPathData(faPhone);
}

export const fa_plus_circle = () => {
    return getSvgIconPathData(faPlusCircle);
}

export const fa_question_circle = () => {
    return getSvgIconPathData(faQuestionCircle);
}

export const fa_sign_out_alt = () => {
    return getSvgIconPathData(faSignOutAlt);
}

export const fa_siren_on = () => {
    return getSvgIconPathData(faSirenOn);
}

export const fa_sort = () => {
    return getSvgIconPathData(faSort);
}

export const fa_star = () => {
    return getSvgIconPathData(faStar);
} //VELAAK

export const fa_stars = () => {
    return getSvgIconPathData(faStars);
}

export const fa_tags = () => {
    return getSvgIconPathData(faTags);
}

export const fa_trash = () => {
    return getSvgIconPathData(faTrash);
}

export const fa_trash_alt = () => {
    return getSvgIconPathData(faTrashAlt);
}

export const fa_user_circle = () => {
    return getSvgIconPathData(faUserCircle);
}

export const fa_users = () => {
    return getSvgIconPathData(faUsers);
}

export const fa_angle_up = () => {
    return getSvgIconPathData(faAngleUp);
}

export const fa_angle_down = () => {
    return getSvgIconPathData(faAngleDown);
}

export const fa_angle_right = () => {
    return getSvgIconPathData(faAngleRight);
}

export const fa_check_circle_bold = () => {
    return getSvgIconPathData(faCheckCircleBold);
}

export const fa_angle_left = () => {
    return getSvgIconPathData(faAngleLeft);
}

export const fa_chevron_down = () => {
    return getSvgIconPathData(faChevronDown);
}

export const fa_minus = () => {
    return getSvgIconPathData(faMinus);
}

export const fa_plus = () => {
    return getSvgIconPathData(faPlus);
}

export const fa_location_circle = () => {
    return getSvgIconPathData(faLocationCircle);
}

export const fa_copy = () => {
    return getSvgIconPathData(faCopy);
}

export const fa_filter = () => {
    return getSvgIconPathData(faFilter);
}

export const fa_caret_down = () => {
    return getSvgIconPathData(faCaretDown);
}

export const fa_user_friends = () => {
    return getSvgIconPathData(faUserFriends);
}

export const fa_facebook_f = () => {
    return getSvgIconPathData(faFacebookF);
}

export const fa_twitter = () => {
    return getSvgIconPathData(faTwitter);
}

export const fa_share_alt = () => {
    return getSvgIconPathData(faShareAlt);
}

export const fa_user_friends_bold = () => {
    return getSvgIconPathData(faUserFriendsBold);
}

export const fa_copy_bold = () => {
    return getSvgIconPathData(faCopyBold);
}

export const fa_euro_sign = () => {
    return getSvgIconPathData(faEuroSign);
}

export const fa_sack = () => {
    return getSvgIconPathData(faSack);
}

export const fa_circle = () => {
    return getSvgIconPathData(faCircle);
}

export const fa_comments_alt = () => {
    return getSvgIconPathData(faCommentsAlt);
}

export const fa_arrow_right = () => {
    return getSvgIconPathData(faArrowRight);
}

export const fa_chevron_right = () => {
    return getSvgIconPathData(faChevronRight);
}

export const fa_chevron_right_bold = () => {
    return getSvgIconPathData(faChevronRightBold);
}

export const fa_credit_card = () => {
    return getSvgIconPathData(faCreditCard);
}

export const fa_credit_card_bold = () => {
    return getSvgIconPathData(faCreditCardBold);
}

export const fa_ban = () => {
    return getSvgIconPathData(faBan);
}

export const fa_minus_circle = () => {
    return getSvgIconPathData(faMinusCircle);
}

export const fa_box_open = () => {
    return getSvgIconPathData(faBoxOpen);
}

export const fa_crown = () => {
    return getSvgIconPathData(faCrown);
}

export const fa_bell = () => {
    return getSvgIconPathData(faBell);
}

export const fa_person_half_dress = () => {
    return getSvgIconPathData(faPersonHalfDress);
}

export const fa_house_person_return = () => {
    return getSvgIconPathData(faHousePersonReturn);
}

export const fa_people_roof = () => {
    return getSvgIconPathData(faPeopleRoof);
}

export const fa_child_reaching = () => {
    return getSvgIconPathData(faChildReaching);
}

export const fa_building_columns = () => {
    return getSvgIconPathData(faBuildingColumns);
}

export const fa_map_pin = () => {
    return getSvgIconPathData(faMapPin);
}

export const fa_spa = () => {
    return getSvgIconPathData(faSpa);
}

export const fa_utensils = () => {
    return getSvgIconPathData(faUtensils);
}

export const fa_reply_all = () => {
    return getSvgIconPathData(faReplyAll);
}

export const fa_id_card = () => {
    return getSvgIconPathData(faIdCard);
}

export const fa_video = () => {
    return getSvgIconPathData(faVideo);
}

export const fa_heart = () => {
    return getSvgIconPathData(faHeart);
}

export const fa_times = () => {
    return getSvgIconPathData(faTimes);
}

export const fa_user = () => {
    return getSvgIconPathData(faUser);
}

export const fa_heart_bold = () => {
    return getSvgIconPathData(faHeartBold);
}

export const fa_check_circle = () => {
    return getSvgIconPathData(faCheckCircle);
}

export const fa_check = () => {
    return getSvgIconPathData(faCheck);
}

export const fa_stars_regular = () => {
    return getSvgIconPathData(faStarsRegular);
}

export const fa_exclamation_triangle_bold = () => {
    return getSvgIconPathData(faExclamationTriangleBold);
}

export const fa_exclamation_triangle_regular = () => {
    return getSvgIconPathData(faExclamationTriangle);
}

export const fa_envelope = () => {
    return getSvgIconPathData(faEnvelope);
}

export const vip_user_icon = () => {
    return {
        width: 512,
        height: 512,
        path: "M 300.78 -84.88 c 69.66 21.06 110.7 49.68 134.46 93.42 c 22.68 41.04 24.84 86.4 6.48 141.48 c -7.56 23.22 -14.04 53.46 -14.04 68.04 c 0 15.66 -3.24 28.62 -7.56 32.4 c -4.32 3.24 -10.26 16.74 -13.5 29.7 c -11.88 46.98 -47.52 69.66 -91.26 57.24 c -28.08 -7.56 -37.26 -16.2 -54.54 -49.68 c -8.1 -15.66 -18.36 -28.62 -22.68 -28.62 c -4.32 0 -12.42 10.26 -18.36 22.68 c -23.22 47.52 -57.78 66.96 -99.36 55.62 c -24.84 -6.48 -41.04 -24.84 -50.22 -56.16 c -3.24 -11.88 -9.18 -25.92 -13.5 -30.78 c -3.78 -4.32 -7.02 -12.42 -7.02 -17.28 c -0 -5.4 -8.64 -27.54 -19.44 -49.14 c -23.76 -49.68 -28.62 -86.94 -16.2 -128.52 c 8.64 -30.24 32.4 -58.32 49.14 -58.32 c 3.78 -0 15.12 9.18 24.3 19.98 l 17.28 20.52 l -11.34 -21.6 c -6.48 -11.88 -11.34 -26.46 -11.34 -32.94 c -0 -18.36 22.68 -46.98 48.6 -61.56 c 21.06 -11.34 32.4 -13.5 81 -14.58 c 42.12 -1.08 64.8 1.08 89.1 8.1 z m -183.6 145.26 c 7.56 11.34 13.5 22.14 13.5 23.76 c 0 2.16 -7.56 4.86 -17.28 7.02 c -35.64 7.02 -43.74 22.14 -49.68 92.34 l -2.7 32.4 l 49.68 -0 c 27.54 -0 67.5 3.24 88.56 7.56 c 34.02 6.48 44.82 6.48 78.3 -0 c 21.6 -4.32 61.56 -7.56 88.56 -7.56 l 49.14 -0 l -2.7 -40.5 c -2.7 -48.6 -11.88 -68.58 -35.1 -77.76 c -29.7 -12.42 -188.46 -21.06 -212.76 -12.42 c -10.26 3.78 -16.2 0.54 -35.1 -19.98 c -12.96 -13.5 -23.76 -24.84 -24.84 -24.84 c -0.54 0 4.86 9.18 12.42 19.98 z M 63.18 337.4 c 2.16 5.94 12.96 22.14 24.84 35.64 c 23.76 27.54 42.66 61.02 42.66 76.14 c 0 7.56 3.78 5.4 14.04 -8.1 c 42.66 -54 147.42 -54.54 186.84 -1.08 l 11.88 16.74 l 7.02 -24.3 c 4.32 -13.5 17.28 -35.1 31.32 -50.76 c 13.5 -14.58 26.46 -32.4 29.16 -39.42 c 4.86 -11.88 5.4 -10.8 5.4 7.02 c 0.54 11.34 -2.7 30.78 -7.02 43.2 c -4.32 12.96 -10.26 36.18 -13.5 51.84 c -3.24 15.66 -9.18 35.1 -13.5 43.2 c -12.96 24.84 -58.86 64.8 -83.7 73.98 c -28.62 9.72 -92.88 10.26 -120.96 0.54 c -19.98 -7.56 -65.34 -44.28 -79.38 -65.34 c -11.34 -16.74 -46.98 -163.08 -41.04 -169.02 c 1.08 -1.08 3.78 3.24 5.94 9.72 z m 113.4 110.16 c -47.52 19.98 -32.94 78.3 19.98 81 c 16.74 0.54 17.82 -0.54 16.2 -16.74 c -1.62 -14.58 -0 -17.82 11.88 -21.06 c 7.56 -1.62 20.52 -1.62 28.08 -0 c 11.88 3.24 13.5 6.48 11.88 21.06 c -1.62 16.2 -0.54 17.28 16.2 16.74 c 51.84 -2.7 67.5 -60.48 21.06 -80.46 c -23.22 -10.26 -100.98 -10.26 -125.28 -0.54 z"
    };
}

/**
 * Get the SVG icon path data for reactivity purposes.
 *
 * This function is used to retrieve the path data of an SVG icon for the purpose of maintaining reactivity.
 * When creating SVG icons through Unicode, they lose their reactivity. This function allows you to extract
 * the specific path data required for SVG reactivity.
 *
 * @param {Object} svg - The SVG object containing the icon data.
 * @returns {{path: *, width: *, height: *}} The path data of the SVG icon.
 */
function getSvgIconPathData(svg) {
    return {
        width: svg.icon[0],
        height: svg.icon[1],
        path: svg.icon[4],
    };
}
